import BillOfMaterialFilterHeader from './BillOfMaterialFilterHeader';
import BillOfMaterialTable from './BillOfMaterialTable';

const BillOfMaterialPage = () => {
  return (
    <>
      <div className={'bg-white rounded'}>
        <BillOfMaterialFilterHeader />
        <BillOfMaterialTable />
      </div>
    </>
  );
};

export default BillOfMaterialPage;
